import { ElementRef } from '@angular/core';
import flatpickr from 'flatpickr';
import { DateTime } from 'luxon';
import { Options } from 'flatpickr/dist/types/options';
import { Hungarian } from 'flatpickr/dist/l10n/hu';
import Instance = flatpickr.Instance;

type FlatpickrType = 'datepicker' | 'datetimepicker';

export class FlatpickrDirectiveBase {
  private _flatpickrReadyFn = (selectedDates: Date[], dateStr: string, instance: Instance) => {
    const inputElement = instance.element as HTMLInputElement;
    const dateTime = DateTime.fromISO(inputElement.value as string);
    if (dateTime.isValid) {
      instance.setDate(dateTime.toJSDate());
      instance.element.dataset.iso = inputElement.value;
    }
  };

  private _flatpickrOptions?: Options;

  constructor(private _element: ElementRef, private _type: FlatpickrType) {}

  protected init(options?: Options): void {
    this._flatpickrOptions = options;
    this._element.nativeElement.classList.add('app-flatpickr');
    const fp = flatpickr(this._element.nativeElement, this.getConfig(this._type));
    fp.altInput!.onblur = () => this._element.nativeElement.dispatchEvent(new FocusEvent('blur'));
  }

  private getConfig(type: FlatpickrType): Options {
    switch (type) {
      case 'datepicker':
        return {
          locale: this._flatpickrOptions?.locale ?? Hungarian,
          dateFormat: this._flatpickrOptions?.dateFormat ?? 'Z',
          altInput: this._flatpickrOptions?.altInput ?? true,
          altFormat: this._flatpickrOptions?.altFormat ?? 'Y. F j.',
          onReady: this._flatpickrOptions?.onReady ?? this._flatpickrReadyFn,
          maxDate: this._flatpickrOptions?.maxDate,
          minDate: '1900-01-01'
        };
      case 'datetimepicker':
      default:
        return {
          locale: this._flatpickrOptions?.locale ?? Hungarian,
          dateFormat: this._flatpickrOptions?.dateFormat ?? 'Z',
          enableTime: this._flatpickrOptions?.enableTime ?? true,
          altInput: this._flatpickrOptions?.altInput ?? true,
          altFormat: this._flatpickrOptions?.altFormat ?? 'Y. F. j. H:i',
          onReady: this._flatpickrOptions?.onReady ?? this._flatpickrReadyFn,
          maxDate: this._flatpickrOptions?.maxDate,
          minDate: '1900-01-01'
        };
    }
  }
}
